export function buildAvailabilityDescription(availabilityTier?: number) {
  switch (availabilityTier) {
    case 1:
      return '1-5 business days';
    case 2:
      return '2-10 business days';
    case 3:
      return '4 weeks';
    case 4:
      return '12 weeks (may require synthesis)';
    case 5:
      return 'Require custom quote (POA)';
    default:
      return 'Unknown';
  }
}
